// extracted by mini-css-extract-plugin
export var colorSquare = "_q1-0";
export var danger = "_q1-5";
export var lightPink = "_q1-8";
export var neutralBlue = "_q1-7";
export var neutralYellow = "_q1-6";
export var normal = "_q1-1";
export var primary = "_q1-2";
export var primaryLight = "_q1-3";
export var solidBlack = "_q1-g";
export var solidGreen = "_q1-b";
export var solidLightBlue = "_q1-d";
export var solidNavy = "_q1-c";
export var solidOrange = "_q1-f";
export var solidPink = "_q1-e";
export var solidRed = "_q1-9";
export var solidYellow = "_q1-a";
export var success = "_q1-4";